import { Page } from '@/components';
import HistoricTabs from './HistoricTabs';
import LiquidationsTable from './LiquidationsTable';
import OverviewKpis from './OverviewKpis';

export default function LiquidationsPage() {
  return (
    <Page title="Liquidations">
      <OverviewKpis />
      <HistoricTabs />
      <LiquidationsTable />
    </Page>
  );
}
